export class Constants {

    public static VERSION = 'v2.03 build 15';

    public static TOKEN_KEY = 'ACCESS_TOKEN';
    public static SCREENS_VIEW_MODE_KEY = 'SCREENS_VIEW_MODE';
    public static BUSINESS_TABLE_STATE_KEY = 'BUSINESS_TABLE_STATE';

    public static DATE_FORMAT = 'dd/MM/yyyy';

    public static DATE_FORMAT_FOR_PYTHON = 'yyyy-MM-dd';
    // This date format is fixed and cannot be changed because Python's date parsing requires the year-month-day format exactly as 'yyyy-MM-dd'


    public static ZIOCODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 ]{3,6}[A-Za-z0-9]$/;
    public static MOBILE_PATTERN = /^\+?\d{7,15}$/;
    public static NUMBER_FORMAT_PATTERN = '1.0-2';

    public static APP_ROUTES = {
        home: '',
        login: 'login',
        dashboard: 'dashboard',
        businessList: 'business',
        businessDetail: (id: string | number) => `business/${id}`,
        adManager: 'ad-manager',
        screensList: 'screens',
        screenDetail: (id: string | number) => `screens/${id}`
    };

    public static NOTIFY_MESSAGES = {
        error: 'An error occurred while processing.',
        requiredFields: 'Please fill all required fields.',
        emptyLineItem: 'Atleast one item is required to generate invoice.',
        billingAddressRequired: 'Billing address is required for generating invoice.',
        waterMarkSettingUpdated: 'Watermark setting updated.',
        launcherSettingUpdated: 'Launcher setting updated.',
        billingAddressUpdated: ' Billing address updated.'
    }

}
